import { ApplicationRef, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { map } from 'rxjs';
import { ApiService } from '../api/api.service';
import { set } from 'date-fns';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SioService {
  private static socketInstance: any;
  socket: any;
  constructor(public api: ApiService, private appRef: ApplicationRef) {
    // this.init_socket();
  }
  public init_socket() {
    if (SioService.socketInstance) {
      this.socket = SioService.socketInstance;
      console.log("🧩 Socket.IO déjà initialisé, réutilisation de l'instance.");
      return;
    }

    const id_entreprise = this.api.infos?.current_entreprise?.id_entreprise;
    if (id_entreprise) {
      const params = {
        appid: '1',
        roomid: String(id_entreprise),
        token: String(this.api.infos.token.token_key),
        data: JSON.stringify({ user: this.api.infos.utilisateur, device: "web" }),
      };

      console.log('🧩 Initialisation unique de Socket.IO avec :', params);

      this.socket = new Socket({
        url: environment.sio_base_url,
        options: { extraHeaders: params },
      }, this.appRef);

      SioService.socketInstance = this.socket;
    }
    if (!id_entreprise) {
      console.warn('❌ id_entreprise non défini, socket non initialisé');
      return;
    }
  }
  // update(data: any) {
  //   console.log('send: ', data);
  //   this.socket?.emit('update', data);
  // }
  // ecouteurs() {
  //   this.socket
  //     ?.fromEvent('update')
  //     .pipe(map((data: any) => console.log('update : ', data)));
  //   this.socket
  //     ?.fromEvent('getUsers')
  //     .pipe(map((data: any) => console.log('getUsers : ', data)));
  // }
  getSocket(): any {
    return this;
  }
  on_change(
    message_add: any,
    message_edit: any,
    callback: (data: any) => void
  ) {
    this.socket?.on('connect', async (data: any) => {
      //console.log("connect = ", data);
      this.socket?.on('message', (data: any) => {
        if (data.type == message_add || data.type == message_edit) {
          console.log('message = ', data);
          callback(data); // Exécuter la fonction de rappel fournie
        }
      });
    });
  }
  on_update(callback: (data: any) => void) {
    this.socket?.on('connect', async (data: any) => {
      //console.log("connect = ", data);
      this.socket?.on('update', (data: any) => {
        console.log('update = ', data);
        callback(data); // Exécuter la fonction de rappel fournie
      });
    });
  }
  on_change_details(message: any, callback: () => void) {
    this.socket?.on('connect', async (data: any) => {
      //console.log("connect = ", data);
      this.socket?.on('message', (data: any) => {
        if (data.type == message) {
          console.log('message = ', data);
          callback();
        }
      });
    });
  }
}
